<ng-container *ngIf="selectedRows.length > 0; else noSelectedData">
  <mat-accordion class="lum-accordion" togglePosition="before" multi>
    <mat-expansion-panel
      *ngIf="selectedRows.length > 0 && !isSelectAllRows"
      expanded
      class="lum-mat-expansion-panel lum-mat-expansion-panel--border"
    >
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          Items
          <span *ngIf="selectedRows.length > 0" class="ml-1"
            >({{ (selectedRows || []).length }})</span
          ></mat-panel-title
        >
      </mat-expansion-panel-header>
      <div class="mb-2 d-flex justify-content-end">
        <button
          type="button"
          (click)="createPurchaseOrder()"
          class="btn btn-primary mr-2"
          >Create Purchase Order</button
        >
        <button
          type="button"
          (click)="createTransferOrder()"
          class="btn btn-secondary"
          >Transfer Order</button
        >
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Warehouse Group</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of selectedRows; trackBy: trackById">
            <td class="align-middle">
              <span class="d-block">{{ item.internalSku }}</span>
              <span class="d-block small text-muted">{{ item.productName }}</span>
            </td>
            <td class="align-middle">
              <span class="d-block">{{ item.warehouseGroupLabel }}</span>
            </td>
            <td class="align-middle">
              <span class="d-block">{{ item.availableQty | decimalPlaces }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </mat-expansion-panel>
  </mat-accordion>
</ng-container>

<ng-template #noSelectedData>
  <div class="d-flex justify-content-center align-items-center h-100">
    <lum-ui-empty-page title="No item is selected"></lum-ui-empty-page>
  </div>
</ng-template>
